import * as types from '../constants/ActionTypes'
import api from '../utils/api'
import config from '../config'

let afterGetCompanyDetails = (company) => {
    if (company.errCode == 0) {
        return {
            type: types.GET_COMPANY_DETAILS,
            payload: {
                company:company.result
            }
        }
    } else {
        return {
            type: types.GET_COMPANY_DETAILS,
            payload: {},
            error: true
        }
    }
}

let getCompanyDetails = () => {
    var url = '/companies/details/'+config.companyId
    return dispatch => {
        return api(url).get()
            .then(company => dispatch(afterGetCompanyDetails(company)))
            .catch(err => {
                dispatch(afterGetCompanyDetails({error: true}))
            })
    }

}


export default {
    getCompanyDetails
    
}
